import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import EducationPage from "./pages/EducationPage";
import ExperiencePage from "./pages/ExperiencePage";
import DiplomasPage from "./pages/DiplomasPage";
import GenAIProjectsPage from "./pages/GenAIProjectsPage";
import DeepLearningProjectsPage from "./pages/DeepLearningProjects";
import MachineLearningProjectsPage from "./pages/MachineLearningProjectsPage";
import MLOpsProjectsPage from "./pages/MLOpsProjectsPage";
import NumericalAnalysisProjectsPage from "./pages/NumericalAnalysisProjectsPage";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/education" element={<EducationPage />} />
        <Route path="/experience" element={<ExperiencePage />} />
        <Route path="/diplomas" element={<DiplomasPage />} />
        <Route path="/genai-projects" element={<GenAIProjectsPage />} />
        <Route
          path="/deeplearning-projects"
          element={<DeepLearningProjectsPage />}
        />
        <Route
          path="/machinelearning-projects"
          element={<MachineLearningProjectsPage />}
        />
        <Route path="/mlops-projects" element={<MLOpsProjectsPage />} />
        <Route
          path="/numerical-projects"
          element={<NumericalAnalysisProjectsPage />}
        />
      </Routes>
    </Router>
  );
};

export default App;
